export default __webpack_public_path__ + "static/media/addLanguagePlus.9dfa7ba7.svg";